const formatDateISO = (value) => (value ? value.toISOString().substr(0, 10) : null);

export default formatDateISO;
